import Modal from '@/components/common-modal/modal';
import { ClientDashboard, PageStyle, Link, Clipboard, Button, Tooltip, ErrorPages, CareerSettingAction, 
          useRouter, useState, REDIRECT, CAREER_SETTING, ConfirmationModal, closeModalUsingState, motion,
          PAGE_ANIMATION_OPTIONS, QuickAdd, redirectToCareerPage, useEffect, ActivitiesAction, useSWR, getCustomizeCareerData, SidebarAction, clearSWRCache, SkipModal, useTranslation, ButtonStyle } from '@/imports-files/pages/career/career-setting';
import CPageStyle from "@/styles/pages/reschadual-interview/_index.module.scss";
import {default as ErrorExclamation} from 'public/icons/error_exclamation.svg';

function CareerSetting(props)
{
    clearSWRCache('career_setting_data')
    const router                                    =     useRouter();
    const [apiError, setApiError]                   =     useState(null);
    const errorPages                                =     new ErrorPages()
    const careerSettingAction                       =     new CareerSettingAction(setApiError);
    const activitiesAction                          =     new ActivitiesAction(setApiError);
    const { data, error }                           =     useSWR('career_setting_data', () => { return(getCustomizeCareerData(router, setApiError))}, {revalidateOnFocus: false});
    const [flagForRerender, setFlagForRerender]     =     useState(0);
    const [clipboardMessage, setClipBoardMessage]   =     useState('Copy Link');
    const [careerClipboardMessage, setCareerClipBoardMessage]   =     useState('Copy Link');
    const [link, setLink]                           =     useState(window.location.protocol+'//'+window.location.host+'/careers');
    const [iFrameLink, setIframeLink]               =     useState(window.location.protocol+'//'+window.location.host+'/job-openings');
    const [confirmation, setConfirmation]           =     useState(false);
    const step                                      =     router.query.step
    const isQuickSetup                              =     router.query.step && router.query.step == 'careers_page' ? true : false
    const [skipModal, setSkipModal]                 =     useState(false);
    const { t, i18n }                               =     useTranslation();
    const [isPublished, setIsPublished]             =     useState(false);
    const [isLoading, setIsLoading]                 =     useState(true);
    const [readAccess, setReadAccees]               =     useState(props.session.role == 'SubAdministrator' ? true : false);
    const [customCareerLink, setCustomCareerLink] = useState("");
    const [customCareerLinkDisabled, setCustomCareerLinkDisabled] =
      useState(false);
    const [editableCustomCareerLink, setEditableCustomCareerLink] = useState(false );
    const [urlError, setUrlError] = useState(false)
    const isValidURL = (url) => {
      if(!url) return true
      return CAREER_SETTING.urlRegex.test(url);
    };
    const [customCareerLinkValue, setCustomCareerLinkValue] = useState("")

    useEffect(()=>{
      if(data)
      {
        if (data.custom_back_url || data.career_page_published) {
          setCustomCareerLink(data.custom_back_url || link);
          setCustomCareerLinkValue(data.custom_back_url || link)
          setEditableCustomCareerLink(true)
          setCustomCareerLinkDisabled(true)
        }
        setIsPublished(data.career_page_published);
        setIsLoading(false);
         if(isQuickSetup)
          setTimeout(() => {
            new SidebarAction().subsidebarQuickSetupChangeIcon(
              data.sidebar_options.complete_steps,
              "careers_page"
            );
          }, 750);
      }
    }, [data])

    if(errorPages.handleErrorCodes(apiError?.status))
    {
      var renderPage  =  ( apiError) ? errorPages.renderPage(apiError?.status, router) : null;
      return renderPage; 
    } 
    if(isLoading) return "";
    return (
      <motion.div key={router.route} initial="pageInitial" animate="pageAnimate" variants={PAGE_ANIMATION_OPTIONS}>
       <div className={`JobListPage TeamList DashboardPageContent ${PageStyle.JobList} ${PageStyle.NewJob}`}>
       <div className={PageStyle.NewJob__Container}>
       <div className={PageStyle.ClientCompany__TopSection2}>
          <div className={PageStyle.JobsApi__QuickAdd}>
            <QuickAdd session={props.session}/>
          </div>
        </div>
       <div className={PageStyle.ClientCompany__FormSection}>
          <h1 className={` mt0 ${PageStyle.ClientCompany__Heading}`}>
            Career Site: <span className={PageStyle.ClientCompany__Company}>Settings</span>
          </h1>

          <span className={PageStyle.PrivacyPolicy__PrivacySubhead}>
          Click on the copy icon below to get the link to your career page or jobs iframe.
          </span>
       </div>

      {isPublished ?
        <div className={PageStyle.CareerSetting}>
          <span className={PageStyle.Form__Label}> Default link to careers page</span>
          <div className={`${PageStyle.CareerSetting__Inputbox} ${PageStyle.Form__Input}`}>
            <input
              type="text"
              value={link}
              disabled={false}
            />
            <label>
              <Tooltip className='SimpleTooltip CareerSettingTooltip' content={careerClipboardMessage} {...CAREER_SETTING.tooltip}>
                <span  className  =   "CareerPageTooltip"
                       onClick    =   {()=> careerSettingAction.copyToClipboard(link, setCareerClipBoardMessage)}>
                  <Clipboard className="clipboardsvg" />
                </span>
              </Tooltip>
            </label>
          </div>
        </div>
      :
      <Tooltip className={"CareerSettingsTooltip SimpleTooltip"} content={"You have not published a career page yet."} {...CAREER_SETTING.tooltip}>
        <div className={`${PageStyle.CareerSetting}`}>
          <span className={PageStyle.Form__Label}> Default link to careers page</span>
          <div className={`${PageStyle.CareerSetting__Inputbox} ${PageStyle.Form__Input} ${isPublished ? '' : PageStyle.CareerSetting__Inputbox__disabled}`}>
            <input
              type="text"
              value={""}
              disabled={true}
            />
          </div>
        </div>
      </Tooltip>}

       {/* ----------------Custom Career Page Link Start------------------ */}
        <div className={`mt30 ${PageStyle.CareerSetting}`}>
          <span className={PageStyle.Form__Label}>
            Custom careers page link
          </span>
          <div
            className={`${PageStyle.CareerSetting__Inputbox} ${
              PageStyle.Form__Input
            }
            ${
              customCareerLinkDisabled &&
              PageStyle.CareerSetting__Inputbox__disabled
            }
            `}
          >
            <input
              type="text"
              value={customCareerLink}
              onChange={(e) => {
                setCustomCareerLink(e.target.value);
                setEditableCustomCareerLink(false);
              }}
              readOnly={customCareerLinkDisabled}
            />
            <label>
              <Tooltip
                className='SimpleTooltip'
                content={clipboardMessage}
                {...CAREER_SETTING.tooltip}
              >
                <span
                  className="CareerPageTooltip"
                  onClick    =   {()=> careerSettingAction.copyCustomToClipboard(customCareerLink, setClipBoardMessage)}
                >
                  <Clipboard className="clipboardsvg" />
                </span>
              </Tooltip>
            </label>
          </div>
          {urlError && (
            <div
              className={PageStyle.CareerSetting__Inputbox__Error}
              style={{ alignItems: "center" }}
            >
              <ErrorExclamation /> <span>{"Please enter valid url"}</span>
            </div>
          )}
          <div className={`${CPageStyle.IconsRight}`}>
            {!customCareerLinkDisabled && !editableCustomCareerLink ? (
              <>
                <Tooltip className='SimpleTooltip' content={`Save`} {...CAREER_SETTING.tooltip}>
                  <Button
                    buttonstyle={`${CPageStyle.SelectTimeSlots__NoBtn} contact_confirm_tooltipwidth100`}
                    onClick={async () => {
                      if (!isValidURL(customCareerLink)) {
                        setUrlError(true);
                      } else {
                        setUrlError(false);
                        await careerSettingAction.customCareerPageLink(
                          customCareerLink,
                          setCustomCareerLink,
                          setFlagForRerender,
                          setCustomCareerLinkValue
                        );
                        setEditableCustomCareerLink(true);
                        setCustomCareerLinkDisabled(true)
                      }
                    }}
                  >
                    <img src="/icons/right.png" alt="" />
                  </Button>
                </Tooltip>
                <Tooltip className='SimpleTooltip' content={`Cancel`} {...CAREER_SETTING.tooltip}>
                  <Button
                    buttonstyle={`${CPageStyle.SelectTimeSlots__NoBtn} contact_confirm_tooltipwidth100`}
                    onClick={() => {
                      setCustomCareerLinkDisabled(true);
                      setUrlError(false);
                      setCustomCareerLink(customCareerLinkValue)
                    }}
                  >
                    <img src="/icons/cancel.png" alt="" />
                  </Button>
                </Tooltip>
              </>
            ) : (
              <Tooltip className='SimpleTooltip' content={`Edit`} {...CAREER_SETTING.tooltip}>
                <div
                  className={`${CPageStyle.SelectTimeSlots__NoBtn} contact_confirm_tooltipwidth100`}
                  onClick={() => {
                    setCustomCareerLinkDisabled(false);
                    setEditableCustomCareerLink(false);
                  }}
                >
                  <img
                    src="/icons/edit.png"
                    className={`${CPageStyle.EditIcon}`}
                    alt="Edit Icon"
                  />
                </div>
              </Tooltip>
            )}
          </div>
        </div>


      <div className={`mt30 ${PageStyle.CareerSetting}`}>
        <span className={PageStyle.Form__Label}> Jobs iFrame</span>
        <div className={`${PageStyle.CareerSetting__Inputbox} ${PageStyle.Form__Input}`}>
        <input
          type="text"
          disabled={readAccess}
          value={ careerSettingAction.getIframeValue(iFrameLink)}
          className={readAccess ? 'no-scroll-input' : ''}
        />
        <label>
        <Tooltip className='SimpleTooltip' content={clipboardMessage} {...CAREER_SETTING.tooltip}>

          <span  className  =   {`CareerPageTooltip ${readAccess ? 'cursor-nodrop' : ''}`}
                 onClick    =   {()=> !readAccess ? careerSettingAction.copyToClipboard(careerSettingAction.getIframeValue(iFrameLink), setClipBoardMessage) : ''}>
            <Clipboard className={`clipboardsvg ${readAccess ? 'disabledSvgFill' : ''}`} />
          </span>

        </Tooltip>

        </label>
        </div>

      </div>
             {/* ----------------Custom Career Page Link End------------------ */}

      <div className={PageStyle.CareerSettingButton}>
        {/* <Button buttonstyle={PageStyle.secondarybtnborder} onClick={()=>{console.log('Reset')}}> Reset Careers Page</Button> */}
        <Button buttonstyle={PageStyle.primarybtn} onClick={() => redirectToCareerPage()}> Customise Careers Page</Button>
      </div>


      {isQuickSetup && <div className={PageStyle.NewJob__SubmitSection}>
        <Button buttonstyle  =  {PageStyle.secondarybtnborder}
                type         =  "button"
                onClick      =  {() => { setSkipModal(true) }}
        >
        Skip
        </Button>

        <Button buttonstyle  = {PageStyle.primarybtn}
                type         = "button"
                onClick={()=>{ activitiesAction.nextOnboardingStep(step, router) }}
        >
        Next
        </Button>
      </div>}

      </div>
      </div>

      {skipModal && <SkipModal setBtnPopup={setSkipModal} router={router}></SkipModal>}
      {/* -------------------- UNSUCCESSFUL REASONS DELETE MODAL -------------------- */}
      {confirmation && (
        <Modal
          type="confirmation"
          message={CAREER_SETTING.texts.modal.message}
          closeModal={() => {
            closeModalUsingState(false, setConfirmation);
          }}
          btnAction={() => {
            careerSettingAction.resetCarrerPage(
              setFlagForRerender,
              setConfirmation
            );
          }}
          texts={{
            button2_text: CAREER_SETTING.texts.modal.button_2,
          }}
        />
      )}
      {/* -------------------- UNSUCCESSFUL REASONS DELETE MODAL -------------------- */}
      </motion.div>      
    )

}

CareerSetting.layout = ClientDashboard;
export default CareerSetting;